__turbopack_context__.v({
  "actions": "Finance-module__wS9nva__actions",
  "backlink": "Finance-module__wS9nva__backlink",
  "bigBrand": "Finance-module__wS9nva__bigBrand",
  "bigNeg": "Finance-module__wS9nva__bigNeg",
  "bigPos": "Finance-module__wS9nva__bigPos",
  "bigfig": "Finance-module__wS9nva__bigfig",
  "btnAnchor": "Finance-module__wS9nva__btnAnchor",
  "btnAnchorPrimary": "Finance-module__wS9nva__btnAnchorPrimary",
  "eyebrow": "Finance-module__wS9nva__eyebrow",
  "hint": "Finance-module__wS9nva__hint",
  "lead": "Finance-module__wS9nva__lead",
  "legend": "Finance-module__wS9nva__legend",
  "page": "Finance-module__wS9nva__page",
  "pageWide": "Finance-module__wS9nva__pageWide",
  "recoBody": "Finance-module__wS9nva__recoBody",
  "recoChevron": "Finance-module__wS9nva__recoChevron",
  "recoDanger": "Finance-module__wS9nva__recoDanger",
  "recoDesc": "Finance-module__wS9nva__recoDesc",
  "recoIco": "Finance-module__wS9nva__recoIco",
  "recoIcoGreen": "Finance-module__wS9nva__recoIcoGreen",
  "recoIcoRed": "Finance-module__wS9nva__recoIcoRed",
  "recoIcoWarn": "Finance-module__wS9nva__recoIcoWarn",
  "recoLink": "Finance-module__wS9nva__recoLink",
  "recoList": "Finance-module__wS9nva__recoList",
  "recoTitle": "Finance-module__wS9nva__recoTitle",
  "sectionH": "Finance-module__wS9nva__sectionH",
  "split": "Finance-module__wS9nva__split",
  "stack": "Finance-module__wS9nva__stack",
  "statGrid": "Finance-module__wS9nva__statGrid",
  "tile": "Finance-module__wS9nva__tile",
  "tileK": "Finance-module__wS9nva__tileK",
  "tileS": "Finance-module__wS9nva__tileS",
  "tileV": "Finance-module__wS9nva__tileV",
  "tileVBrand": "Finance-module__wS9nva__tileVBrand",
  "tileVNeg": "Finance-module__wS9nva__tileVNeg",
  "tileVPos": "Finance-module__wS9nva__tileVPos",
  "tileVWarn": "Finance-module__wS9nva__tileVWarn",
  "tint": "Finance-module__wS9nva__tint",
  "tintBrand": "Finance-module__wS9nva__tintBrand",
  "tintGreen": "Finance-module__wS9nva__tintGreen",
  "tintRed": "Finance-module__wS9nva__tintRed",
  "tintStone": "Finance-module__wS9nva__tintStone",
  "tintWarn": "Finance-module__wS9nva__tintWarn",
  "title": "Finance-module__wS9nva__title",
});
